var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"show-nav":true},on:{"navSwitch":_vm.navSwitch}},[_c(_vm.componentId,{key:_vm.componentId,tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }